import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user.js';
import exportFile from './modules/exportFile';
import smsConsumeRecord from './modules/smsConsumeRecord';
// import activityInfo from './modules/activityInfo';
// import activitySetting from './modules/activitySetting';

// import activityManage from './modules/activityManage';
// import tickets from './modules/ticketsRecord';
// import invoice from './modules/invoices';

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		user,
		exportFile,
		// activityInfo,
		// activitySetting,
		// activityManage,
		// tickets,
		// invoice,
		smsConsumeRecord,
	},
});

// if (module.hot) {
// 	// 使 actions 和 mutations 成为可热重载模块
// 	module.hot.accept([
// 		'./modules/user',
// 		'./modules/activityInfo',
// 		'./modules/activitySetting'
// 	], () => {
// 		// 获取更新后的模块
// 		// 因为 babel 6 的模块编译格式问题，这里需要加上 .default
// 		const newMutations = require('./mutations').default;
// 		// 加载新模块
// 		store.hotUpdate({
// 			mutations: newMutations
// 		});
// 	});
// }

export default store;
